import ReactPaginate from 'react-paginate';
import './Pagination.scss';
import PropTypes from "prop-types";
import {NextIcon, PreviousIcon} from "./PaginationSVG.jsx";

const Pagination = ({pageCount, onPageChange, paginationClass}) => {

  try {
    return (
      <ReactPaginate
        previousLabel={<PreviousIcon/>}
        nextLabel={<NextIcon/>}
        breakLabel={'...'}
        breakClassName={'break-me'}
        pageCount={pageCount}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        onPageChange={onPageChange}
        containerClassName={'pagination'}
        subContainerClassName={'pages pagination'}
        activeClassName={'active'}
        className={paginationClass}
      />
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

Pagination.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  paginationClass: PropTypes.string.isRequired,
  pageCount: PropTypes.number.isRequired,
}

export default Pagination;